import Slider from 'react-slick';
import {
  slide1,
  slide2,
  slide3,
  slide4,
  ScrollDown,
  SlideArrowLeft,
  SlideArrowRight,
} from '../../image';
import styles from './mobileslider.module.scss';
export default function MobileSlide(props) {
  const SlickArrowLeft = ({ className, style, onClick }) => (
    <button
      className={`${className} ${styles['left__arrow']} ${styles['clear__button']}`}
      style={{
        fontSize: '40px',
        zIndex: '1',
        height: '40px',
        width: '40px',
        opacity: '1',
        color: 'White',
      }}
      onClick={onClick}
    >
      <SlideArrowLeft />
    </button>
  );
  const SlickArrowRight = ({ className, onClick }) => (
    <button
      className={`${className} ${styles['right__arrow']} ${styles['clear__button']}`}
      style={{
        fontSize: '40px',
        zIndex: '1',
        height: '40px',
        width: '40px',
        opacity: '1',
        color: 'White',
      }}
      onClick={onClick}
    >
      <SlideArrowRight />
    </button>
  );
  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
  };
  return (
    <div className={styles['mobileSlider']}>
      <Slider {...settings}>
        {props.content &&
          props.content.details.listImage.map((e) => (
            <div className={styles['slideImg']}>
              <img src={e} alt="" />
            </div>
          ))}
      </Slider>
    </div>
  );
}
